import request from '@/utils/request'

let PromotionApi = {
    getPromotionDetail(data){
         return request._post('/shop/plus.agent.Team/getPromotionDetail', data);
    },
    getPromotionStats(data){
        return request._post('/shop/plus.agent.Team/getPromotionStats', data);
    },
    getPromotionChartData(data){
        return request._post('/shop/plus.agent.Team/getPromotionChartData', data);
    },
    getPromotionTargets(data){
        return request._post('/shop/plus.agent.Team/targets', data);
    },
    getTeamMembers(data){
        return request._post('/shop/plus.agent.Team/getTeamMembers', data);
    },
    getTeamRecords(data){
        return request._post('/shop/plus.agent.Team/getTeamRecords', data);
    },
     getPromotionRecords(params) {
    return request._post('/shop/plus.agent.Team/getRecords', params);
  },
    getAgentStats(data){
        return request._post('/shop/plus.agent.Team/getAgentStats', data);
    },
    getAgentDetail(data){
        return request._post('/shop/plus.agent.Team/getAgentDetail', data);
    },
    getAgentList(data){
        return request._post('/shop/plus.agent.Team/getAgentList', data);
    },
    getTeamInfo(data){
         return request._post('/shop/plus.agent.Team/getTeamInfo', data);
    },
    getPromotionList(data){
         return request._post('/shop/plus.agent.Team/getPromotionList', data);
    },
    getPromotionAnalysis(data){
         return request._post('/shop/plus.agent.Team/getPromotionAnalysis', data);
    },
      searchUser(data) {
        return request._post('/shop/plus.agent.Team/searchUser', data);
      }
}
export default PromotionApi;



// WEBPACK FOOTER //
// ./src/api/promotion.js